import React from 'react';
import { SwiperOptions } from 'swiper';
import { IProps, IChildElement } from 'components/SliderService/types';
import Slider from 'components/Slider';

const SliderService: React.FC<IProps> & IChildElement = (props) => {
  const config: SwiperOptions = {
    breakpoints: {
      1024: {
        slidesPerView: 3
      },
      813: {
        slidesPerView: 2
      }
    }
  };

  return (
    <div className="slider-service">
      <Slider
        name={props.name}
        config={config}
        pagination={false}
      >
        {props.children}
      </Slider>
    </div>
  );
};

SliderService.Item = Slider.Item;

export default SliderService;
